import defaultTheme from './default-theme';

const defaultThemeCopy = JSON.parse(JSON.stringify(defaultTheme));

export const defaultThemeBrandRefresh: any = defaultThemeCopy;
